/* -------------------------------------------------------------------------- */
/*                             Match facts styles                             */
/* -------------------------------------------------------------------------- */

@import './pk-match-facts.variables';

:host {
  @apply block w-full sm:w-[--pk-match-facts--event-max-width];
}

.pk-match-facts__timeline {
  @apply border-0 border-r-[length:--pk-match-facts--line-stroke] border-[color:--pk-match-facts--line-color];

  border-style: var(--pk-match-facts--line-style);
}
